export const CONFIG_TYPES = {
    PROFILE_SETTINGS: 'PROFILE_SETTINGS',
    PROFILE_ADMIN: 'PROFILE_ADMIN',
    MY_PROFILE: 'MY_PROFILE',
    ABOUT: 'ABOUT',
    REFRESH_SESSION: 'REFRESH_SESSION',
    LOGOUT: 'LOGOUT',
    MY_SUBSCRIPTIONS: 'MY_SUBSCRIPTIONS',
    SEE_PROFILES: 'SEE_PROFILES',
};



// WEBPACK FOOTER //
// ./src/containers/config/configTypes.js